import type { MarketIdentifiers } from './types/market';

export const perps: Record<MarketIdentifiers, any> = {
	sETHPERP: {
		displayName: 'ETH-PERP',
		imageUrl: 'tokens/ethereum.png'
	},
	sAVAXPERP: {
		displayName: 'AVAX-PERP',
		imageUrl: 'tokens/avax.svg'
	},
	sDYDXPERP: {
		displayName: 'DYDX-PERP',
		imageUrl: 'tokens/dydx.svg'
	},
	sBTCPERP: {
		displayName: 'BTC-PERP',
		imageUrl: 'tokens/btc.svg'
	},
	sAPEPERP: {
		displayName: 'APE-PERP',
		imageUrl: 'tokens/ape.svg'
	},
	sMATICPERP: {
		displayName: 'MATIC-PERP',
		imageUrl: 'tokens/matic.svg'
	},
	sOPPERP: {
		displayName: 'OP-PERP',
		imageUrl: 'tokens/optimism.svg'
	},
	sARBPERP: {
		displayName: 'ARB-PERP',
		imageUrl: 'tokens/arbitrum.svg'
	},
	sBNBPERP: {
		displayName: 'BNB-PERP',
		imageUrl: 'tokens/bnb.svg'
	},
	sLINKPERP: {
		displayName: 'LINK-PERP',
		imageUrl: 'tokens/chainlink.svg'
	},
	sSOLPERP: {
		displayName: 'SOL-PERP',
		imageUrl: 'tokens/solana.svg'
	},
	sDOGEPERP: {
		displayName: 'DOGE-PERP',
		imageUrl: 'tokens/doge.svg'
	},
	sAAVEPERP: {
		displayName: 'AAVE-PERP',
		imageUrl: 'tokens/aave.svg'
	},
	sUNIPERP: {
		displayName: 'UNI-PERP',
		imageUrl: 'tokens/uniswap.svg'
	},
	sGMXPERP: {
		displayName: 'GMX-PERP',
		imageUrl: 'tokens/gmx.svg'
	},
	sFTMPERP: {
		displayName: 'FTM-PERP',
		imageUrl: 'tokens/fantom.svg'
	},
	sATOMPERP: {
		displayName: 'ATOM-PERP',
		imageUrl: 'tokens/cosmos.svg'
	},
	sNEARPERP: {
		displayName: 'NEAR-PERP',
		imageUrl: 'tokens/near.svg'
	},
	sAXSPERP: {
		displayName: 'AXS-PERP',
		imageUrl: 'tokens/axie.svg'
	},
	sFLOWPERP: {
		displayName: 'FLOW-PERP',
		imageUrl: 'tokens/flow.svg'
	},
	sAPTPERP: {
		displayName: 'APT-PERP',
		imageUrl: 'tokens/apt.png'
	},
	sBCHPERP: {
		displayName: 'BCH-PERP',
		imageUrl: 'tokens/bitcoin-cash.svg'
	},
	sLTCPERP: {
		displayName: 'LTC-PERP',
		imageUrl: 'tokens/litecoin.svg'
	},
	sADAPERP: {
		displayName: 'ADA-PERP',
		imageUrl: 'tokens/cardano.svg'
	},
	sFILPERP: {
		displayName: 'FIL-PERP',
		imageUrl: 'tokens/filecoin.svg'
	},
	sLDOPERP: {
		displayName: 'LDO-PERP',
		imageUrl: 'tokens/lido.svg'
	},
	sCRVPERP: {
		displayName: 'CRV-PERP',
		imageUrl: 'tokens/curve.svg'
	},
	sSHIBPERP: {
		displayName: 'SHIB-PERP',
		imageUrl: 'tokens/shiba.svg'
	},
	sPEPEPERP: {
		displayName: 'PEPE-PERP',
		imageUrl: 'tokens/pepe.webp'
	},
	sSUIPERP: {
		displayName: 'SUI-PERP',
		imageUrl: 'tokens/sui.svg'
	},
	sBLURPERP: {
		displayName: 'BLUR-PERP',
		imageUrl: 'tokens/blur.png'
	},
	sXRPPERP: {
		displayName: 'XRP-PERP',
		imageUrl: 'tokens/xrp.png'
	},
	sDOTPERP: {
		displayName: 'DOT-PERP',
		imageUrl: 'tokens/dot.png'
	},
	sFLOKIPERP: {
		displayName: 'FLOKI-PERP',
		imageUrl: 'tokens/floki.png'
	},
	sINJPERP: {
		displayName: 'INJ-PERP',
		imageUrl: 'tokens/inj.webp'
	},
	sTRXPERP: {
		displayName: 'TRX-PERP',
		imageUrl: 'tokens/trx.png'
	},
	sSTETHPERP: {
		displayName: 'stETH-PERP',
		imageUrl: 'tokens/steth.png'
	},
	sETCPERP: {
		displayName: 'ETC-PERP',
		imageUrl: 'tokens/etc.svg'
	},
	sCOMPPERP: {
		displayName: 'COMP-PERP',
		imageUrl: 'tokens/comp.svg'
	},
	sMKRPERP: {
		displayName: 'MKR-PERP',
		imageUrl: 'tokens/mkr.svg'
	},
	sXMRPERP: {
		displayName: 'XMR-PERP',
		imageUrl: 'tokens/xmr.svg'
	},
	sYFIPERP: {
		displayName: 'YFI-PERP',
		imageUrl: 'tokens/yfi.svg'
	},
	sMAVPERP: {
		displayName: 'MAV-PERP',
		imageUrl: 'tokens/mav.svg'
	},
	sRPLPERP: {
		displayName: 'RPL-PERP',
		imageUrl: 'tokens/rpl.webp'
	},
	sETHBTCPERP: {
		displayName: 'ETH/BTC-PERP',
		imageUrl: 'tokens/ethbtc.png'
	},
	sWLDPERP: {
		displayName: 'WLD-PERP',
		imageUrl: 'tokens/wld.png'
	},
	sUSDTPERP: {
		displayName: 'USDT-PERP',
		imageUrl: 'tokens/usdt.svg'
	},
	sEOSPERP: {
		displayName: 'EOS-PERP',
		imageUrl: 'tokens/eos.png'
	},
	sRUNEPERP: {
		displayName: 'RUNE-PERP',
		imageUrl: 'tokens/rune.svg'
	},
	sXLMPERP: {
		displayName: 'XLM-PERP',
		imageUrl: 'tokens/xlm.png'
	},
	sALGOPERP: {
		displayName: 'ALGO-PERP',
		imageUrl: 'tokens/algo.png'
	},
	sCELOPERP: {
		displayName: 'CELO-PERP',
		imageUrl: 'tokens/celo.svg'
	},
	sSEIPERP: {
		displayName: 'SEI-PERP',
		imageUrl: 'tokens/sei.png'
	},
	sZECPERP: {
		displayName: 'ZEC-PERP',
		imageUrl: 'tokens/zec.svg'
	},
	sKNCPERP: {
		displayName: 'KNC-PERP',
		imageUrl: 'tokens/knc.svg'
	},
	sZILPERP: {
		displayName: 'ZIL-PERP',
		imageUrl: 'tokens/zil.svg'
	},
	s1INCHPERP: {
		displayName: '1INCH-PERP',
		imageUrl: 'tokens/1inch.svg'
	},
	sICPPERP: {
		displayName: 'ICP-PERP',
		imageUrl: 'tokens/icp.svg'
	},
	sXTZPERP: {
		displayName: 'XTZ-PERP',
		imageUrl: 'tokens/xtz.svg'
	},
	sSUSHIPERP: {
		displayName: 'SUSHI-PERP',
		imageUrl: 'tokens/sushi.svg'
	},
	sENJPERP: {
		displayName: 'ENJ-PERP',
		imageUrl: 'tokens/enj.svg'
	},
	sONEPERP: {
		displayName: 'ONE-PERP',
		imageUrl: 'tokens/one.webp'
	},
	sFXSPERP: {
		displayName: 'FXS-PERP',
		imageUrl: 'tokens/fxs.svg'
	},
	sBALPERP: {
		displayName: 'BAL-PERP',
		imageUrl: 'tokens/bal.svg'
	},
	sPERPPERP: {
		displayName: 'PERP-PERP',
		imageUrl: 'tokens/perp.svg'
	},
	sRNDRPERP: {
		displayName: 'RNDR-PERP',
		imageUrl: 'tokens/rndr.png'
	},
	sUMAPERP: {
		displayName: 'UMA-PERP',
		imageUrl: 'tokens/uma.png'
	},
	sZRXPERP: {
		displayName: 'ZRX-PERP',
		imageUrl: 'tokens/zrx.png'
	},
	sSTETHETHPERP: {
		displayName: 'stETH/ETH-PERP',
		imageUrl: 'tokens/stetheth.png'
	},
	sTIAPERP: {
		displayName: 'TIA-PERP',
		imageUrl: 'tokens/tia.png'
	},
	sBONKPERP: {
		displayName: 'BONK-PERP',
		imageUrl: 'tokens/bonk.png'
	},
	sPYTHPERP: {
		displayName: 'PYTH-PERP',
		imageUrl: 'tokens/pyth.png'
	},
	sIMXPERP: {
		displayName: 'IMX-PERP',
		imageUrl: 'tokens/imx.png'
	},
	sTRBPERP: {
		displayName: 'TRB-PERP',
		imageUrl: 'tokens/trb.png'
	},
	sMEMEPERP: {
		displayName: 'MEME-PERP',
		imageUrl: 'tokens/meme.png'
	},
	sANKRPERP: {
		displayName: 'ANKR-PERP',
		imageUrl: 'tokens/ankr.png'
	},
	sFETPERP: {
		displayName: 'FET-PERP',
		imageUrl: 'tokens/fet.png'
	},
	sGRTPERP: {
		displayName: 'GRT-PERP',
		imageUrl: 'tokens/grt.png'
	},
	sJTOPERP: {
		displayName: 'JTO-PERP',
		imageUrl: 'tokens/jto.png'
	},
	sORDIPERP: {
		displayName: 'ORDI-PERP',
		imageUrl: 'tokens/ordi.png'
	},
	sPENDLEPERP: {
		displayName: 'PENDLE-PERP',
		imageUrl: 'tokens/pendle.png'
	},
	sSTRKPERP: {
		displayName: 'STRK-PERP',
		imageUrl: 'tokens/strk.png'
	},
	sCVXPERP: {
		displayName: 'CVX-PERP',
		imageUrl: 'tokens/cvx.png'
	},
	sJUPPERP: {
		displayName: 'JUP-PERP',
		imageUrl: 'tokens/jup.png'
	}
};

export const getDisplayName = function (marketIdentifier: MarketIdentifiers) {
	if (perps.hasOwnProperty(marketIdentifier)) {
		return perps[marketIdentifier]['displayName'];
	} else {
		return 'NA';
	}
};

export const getTokenLogo = function (marketIdentifier: MarketIdentifiers) {
	if (perps.hasOwnProperty(marketIdentifier)) {
		return perps[marketIdentifier]['imageUrl'];
	} else {
		return 'NA';
	}
};
